const VRE_KEY_LABELS = {
  solar: 'Solar',
  windOn: 'Onshore wind',
  windOff: 'Offshore wind',
};

const TECH_LABELS = {
  solar: 'Solar',
  wind_onshore: 'Onshore wind',
  wind_offshore: 'Offshore wind',
};

const REASON_LABELS = {
  'missing_varbl:Avg_cost_elec': 'Average electricity cost (Avg_cost_elec) is missing — merit-order dispatch costs are unavailable.',
  'missing_varbl:Elec Production': 'Electricity production (Elec Production) is missing — reference totals are unavailable.',
};

function formatVreClusterReason(code) {
  const match = /^vre_([^:]+):(\w+)$/.exec(code);
  if (!match) return null;
  const [, issue, vreKey] = match;
  const label = VRE_KEY_LABELS[vreKey] || vreKey;
  switch (issue) {
    case 'fetch_error':
      return `${label}: VO cluster fetch failed — hourly profiles may be incomplete.`;
    case 'clusters_unavailable':
      return `${label}: report shows capacity but VO clusters could not be resolved.`;
    case 'no_clusters':
      return `${label}: report shows capacity but no VO clusters were returned.`;
    case 'report_cluster_mismatch':
      return `${label}: report GW and sum of VO cluster GW differ by more than 1%.`;
    default:
      return `${label}: ${issue.replace(/_/g, ' ')}.`;
  }
}

function formatProfileReason(code) {
  const match = /^vre_(profile|map)_incomplete:(.+)$/.exec(code);
  if (!match) return null;
  const [, kind, tech] = match;
  const label = TECH_LABELS[tech] || tech;
  if (kind === 'profile') {
    return `${label}: some VO clusters are missing DB hourly profiles — the national curve may understate capacity.`;
  }
  return `${label}: some VO clusters could not be mapped to grid cells — the map may be incomplete.`;
}

export function formatDegradedMessage(degradedReasons) {
  if (!Array.isArray(degradedReasons) || degradedReasons.length === 0) {
    return 'Some model data is missing or inconsistent. The simulation may be incomplete.';
  }
  const lines = degradedReasons.map((reason) => {
    if (REASON_LABELS[reason]) return REASON_LABELS[reason];
    return formatVreClusterReason(reason)
      || formatProfileReason(reason)
      || reason.replace(/^missing_varbl:/, 'Missing report variable: ');
  });
  return lines.join(' ');
}

export function collectVreProfileDegradedReasons(vreProfileTraces) {
  if (!vreProfileTraces) return [];
  const reasons = [];
  for (const entry of Object.values(vreProfileTraces)) {
    const fromCoverage = entry?.trace?.profile_coverage?.degradedReasons
      || entry?.coverage?.degradedReasons;
    if (Array.isArray(fromCoverage)) {
      reasons.push(...fromCoverage);
    }
  }
  return [...new Set(reasons)];
}
